import { PhaseContract } from '../models/request-and-responses/rest-api/enums/phaseContract.enum';
import { Color } from './color.enum';

export interface IPhaseObject {
    phase: PhaseContract;
    label: string;
    icon: string;
    icon2: string;
    color: Color;
    color2: Color;
}
export class PhaseObject implements IPhaseObject {
    phase: PhaseContract = null;
    label: string = null;
    icon: string = null;
    icon2: string = null;
    color: Color = null;
    color2: Color = null;
    constructor(po: IPhaseObject) {
        if (
            po != null &&
            po.phase != null &&
            po.label != null &&
            po.icon != null &&
            po.color != null
        ) {
            this.phase = po.phase;
            this.label = po.label;
            this.icon = po.icon;
            this.icon2 = po.icon2;
            this.color = po.color;
            this.color2 = po.color2;
        } else {
            this.label = 'Foo';
            this.icon = 'fas fa-question';
            this.color = Color.Gray;
        }
    }
}
export const PhaseObjects: IPhaseObject[] = [
    {
        phase: PhaseContract.Draft,
        label: 'BOZZA',
        icon: 'fas fa-pencil-alt',
        color: Color.LightBlue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ToConfirmByAgency,
        label: 'DA CONVALIDARE',
        icon: 'fas fa-tasks',
        color: Color.LightBlue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ToConfirmByPatavium,
        label: 'DA CONVALIDARE BACKOFFICE',
        icon: 'fas fa-tasks',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.StopForErrors,
        label: 'FERMO PER ERRORI',
        icon: 'fas fa-thumbs-down',
        color: Color.Orange,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.SwitchingVerification,
        label: 'VERIFICA SWITCHING',
        icon: 'fas fa-thumbs-up',
        color: Color.Gold,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.SwitchingRequest,
        label: 'SWITCHING RICHIESTO',
        icon: 'fas fa-paper-plane',
        color: Color.Gold,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.Validate,
        label: 'VALIDATO',
        icon: 'fas fa-hand-peace',
        color: Color.Green,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.CancelForExceedingTime,
        label: 'ANNULLATO PER SUPERAMENTO TERMINI TEMPORALI',
        icon: 'fas fa-business-time',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.Rejected,
        label: 'RESPINTO',
        icon: 'fas fa-times-circle',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.CancelForChangingOfMind,
        label: 'ANNULLATO PER RIPENSAMENTO',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.Conclusion,
        label: 'CESSATO',
        icon: 'fas fa-skull-crossbones',
        color: Color.Black,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.Exportable,
        label: 'ESPORTABILE',
        icon: 'fas fa-clipboard',
        color: Color.Green,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ExportFail,
        label: 'EXPORT FALLITO',
        icon: 'fas fa-clipboard',
        color: Color.Black,
        icon2: 'fas fa-close',
        color2: Color.Red
    },
    {
        phase: PhaseContract.ExportSuccess,
        label: 'ESPORTATO CON SUCCESSO',
        icon: 'fas fa-trophy',
        color: Color.Gold,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ExportInProgess,
        label: 'EXPORT IN CORSO',
        icon: 'fas fa-cogs',
        color: Color.Gray,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ExportPartial,
        label: 'PARZIALMENTE RIFIUTATO',
        icon: 'fas fa-clipboard',
        color: Color.Black,
        icon2: 'fas fa-exclamation-triangle',
        color2: Color.Red
    },
    {
        phase: PhaseContract.CancelForChangingOfMindEnerp,
        label: 'RIPENSAMENTO ENERP',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.PreCheckOk,
        label: 'PRE-CHECK OK',
        icon: 'fas fa-check-circle',
        color: Color.Green,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.PreCheckKo,
        label: 'PRE-CHECK KO',
        icon: 'fas fa-check-circle',
        color: Color.Gray,
        icon2: 'fas fa-times',
        color2: Color.Red
    },
    {
        phase: PhaseContract.CancelForCMOR,
        label: 'SWITCHING RESPINTO PER CMOR',
        icon: 'fas fa-trash-alt',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.SwitchingRejected,
        label: 'SWITCHING RESPINTO',
        icon: 'fas fa-exchange-alt',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.SwitchingAcquired,
        label: 'SWITCHING ACQUISITO',
        icon: 'fas fa-exchange-alt',
        color: Color.Green,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.LoadingExport,
        label: 'CARICAMENTO IN CORSO',
        icon: 'fas fa-file-export',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ConclusionPartial,
        label: 'PARZIALMENTE CESSATO',
        icon: 'fas fa-bomb',
        color: Color.DarkOrange,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.StoppedByAgency,
        label: 'ANNULLATO DA TEAM',
        icon: 'fa fa-user-alt-slash',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.InAttesaDiAdesione,
        label: 'ATTESA CHIAMATA DI ADESIONE',
        icon: 'fa fa-clock',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AdesioneConfermata,
        label: 'CHECK CHIAMATA DI ADESIONE',
        icon: 'fa fa-phone-volume',
        color: Color.Green,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoDalCliente,
        label: 'ANNULLATO DAL CLIENTE',
        icon: 'fa fa-user-times',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoCausaAgenzia,
        label: 'ANNULLATO CAUSA TEAM',
        icon: 'fa fa-house-damage',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoCausaCte,
        label: 'ANNULLATO CAUSA CTE',
        icon: 'fa fa-file',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RespintoTeleselling,
        label: 'RESPINTO TELESELLING',
        icon: 'fa fa-phone-slash',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AttesaChiamataVerifica,
        label: 'ATTESA CHIAMATA DI VERIFICA',
        icon: 'fa fa-phone-volume',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RifiutatoDopoChiamataVerifica,
        label: 'RIFIUTATO DOPO VERIFICA',
        icon: 'fa fa-headset',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoCausaVincoliTemporali,
        label: 'ANNULLATO CAUSA VINCOLI TEMPORALI',
        icon: 'fas fa-microphone-slash',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RespintoCausaChiamataPreAdesione,
        label: 'RESPINTO PER CHIAMATA DI PRE-VENDITA NON CONFORME',
        icon: 'fas fa-file-audio',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RespintoCausaChiamataAdesione,
        label: 'RESPINTO PRE CHIAMATA DI ADESIONE NON CONFORME',
        icon: 'far fa-file-audio',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoCausaClienteIrreperibile,
        label: 'CLIENTE IRREPERIBILE',
        icon: 'fas fa-search',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoCausaNumeroTelefonicoErrato,
        label: 'NUMERO TELEFONICO ERRATO',
        icon: 'far fa-address-book',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.CheckChiamataDiVerifica,
        label: 'CHECK CHIAMATA DI VERIFICA',
        icon: 'fa fa-headset',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RipensamentoCausaAgenzia,
        label: 'RIPENSAMENTO CAUSA TEAM',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RifiutoRegistrazioneChiamata,
        label: 'RIFIUTO REGISTRAZIONE CHIAMATA',
        icon: 'fas fa-microphone',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RifiutatoCausaChiamataVerifica,
        label: 'RESPINTO PER CHIAMATA DI VERIFICA NON CONFORME',
        icon: 'far fa-frown-open',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.VadAttesaRispostaCliente,
        label: 'VAD - IN ATTESA RISPOSTA CLIENTE',
        icon: 'fas fa-user-clock',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.VadPreValidazioneBackoffice,
        label: 'VAD - PREVALIDAZIONE BACKOFFICE',
        icon: 'far fa-hourglass',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.VadAttesaGestione,
        label: 'VAD - IN ATTESA GESTIONE',
        icon: 'fas fa-stopwatch',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RespintoCausaAllegatoChiamataPreAdesione,
        label: 'RESPINTO PER ALLEGATO CHIAMATA PRE-VENDITA ERRATO',
        icon: "far fa-sticky-note",
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.CambioPiano,
        label: 'CAMBIO PIANO',
        icon: 'fas fa-sync',
        color: Color.DarkOrange,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AttesaEsitoDistributore,
        label: 'IN ATTESA ESITO DISTRIBUTORE',
        icon: 'far fa-pause-circle',
        color: Color.LightBlue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.InAttesaDiAdesionePec,
        label: 'ATTESA ADESIONE PEC',
        icon: 'fas fa-envelope',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RinnovoPerScadenza,
        label: 'RINNOVO PER SCADENZA',
        icon: 'far fa-calendar-times',
        color: Color.Gray,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.Rebranding,
        label: 'RE-BRANDING',
        icon: 'fas fa-exchange-alt',
        color: Color.Gray,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ReCallDisdettato,
        label: 'RE-CALL DISDETTATO',
        icon: 'fas fa-sad-tear',
        color: Color.Gray,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RebrandingAjoSrl,
        label: 'RE-BRANDING - AJO SRL',
        icon: 'fas fa-sync-alt',
        color: Color.Gray,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AttesaSaldo,
        label: 'ATTESA SALDO',
        icon: 'fas fa-hand-holding-usd',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.PropostaAnnullata,
        label: 'PROPOSTA ANNULLATA',
        icon: 'fas fa-dumpster',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RifiutoProposta,
        label: 'RIFIUTO PROPOSTA',
        icon: 'fas fa-thumbs-down',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AttesaRestituzionePlico,
        label: 'ATTESA RESTITUZIONE PLICO',
        icon: 'fas fa-print',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.CheckVocalOrder,
        label: 'CHECK VOCAL ORDER',
        icon: 'fas fa-headphones',
        color: Color.Gold,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.PropostaScaduta,
        label: 'PROPOSTA SCADUTA',
        icon: 'fas fa-history',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.VocalOrderNonConforme,
        label: 'VOCAL ORDER NON CONFORME',
        icon: 'fas fa-headphones',
        color: Color.Gray,
        icon2: 'fas fa-times',
        color2: Color.Red
    },
    {
        phase: PhaseContract.InAttesaDiVerificaPec,
        label: 'IN ATTESA DI VERIFICA PEC',
        icon: 'fas fa-mail-bulk',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AttesaChiamataBenvenuto,
        label: 'ATTESA CHIAMATA DI BENVENUTO',
        icon: 'fas fa-phone-square',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ChiamataBenvenutoEseguita,
        label: 'CHIAMATA DI BENVENUTO ESEGUITA',
        icon: 'fas fa-phone-square',
        color: Color.Green,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AttesaRicevimentoPlicoFirmato,
        label: 'ATTESA RICEVIMENTO PLICO FIRMATO',
        icon: 'fas fa-file-signature',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RichiestaDisdetta,
        label: 'RICHIESTA DISDETTA',
        icon: 'fas fa-user-slash',
        color: Color.Gray,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RichiestaCessazione,
        label: 'RICHIESTA CESSAZIONE',
        icon: 'fas fa-eraser',
        color: Color.Gray,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.InAttesaFirmaDigitale,
        label: 'ATTESA FIRMA DIGITALE',
        icon: 'fas fa-signature',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AttesaVocalOrder,
        label: 'ATTESA VOCAL ORDER',
        icon: 'fas fa-headphones',
        color: Color.Blue,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.PreScreeningKO,
        label: 'RESPINTO PER PRE-SCREENING KO',
        icon: 'fas fa-user',
        color: Color.Gray,
        icon2: 'fas fa-times',
        color2: Color.Red
    },
    {
        phase: PhaseContract.RespintoTuristaEnergetico,
        label: 'SWITCHING RESPINTO TURISTA ENERGETICO',
        icon: 'fas fa-car',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoDatiIncongruenti,
        label: 'ANNULLATO PER DATI INCONGRUENTI',
        icon: 'fas fa-times',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoSwitchMultipli,
        label: 'ANNULLATO PER SWITCH MULTIPLI',
        icon: 'fas fa-times',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RipensamentoTelefonico,
        label: 'RIPENSAMENTO TELEFONICO',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RipensamentoScritto,
        label: 'RIPENSAMENTO SCRITTO',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RipensamentoCondizioniEconomiche,
        label: 'RIPENSAMENTO CONDIZIONI ECONOMICHE',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RipensamentoContatoreChiuso,
        label: 'RIPENSAMENTO CONTATORE CHIUSO',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RipensamentoFrequenzaFatturazione,
        label: 'RIPENSAMENTO FREQUENZA FATTURAZIONE',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RipensamentoContrattoSottoscrittoInconsapevolmente,
        label: 'RIPENSAMENTO PER CONTR. SOTTOSCRITTO INCONS.',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.RipensamentoTerminiPagamento,
        label: 'RIPENSAMENTO TERMINI PAGAMENTO',
        icon: 'fas fa-angry',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoMancanzaDelega,
        label: 'ANNULLATO PER MANCANZA DELEGA',
        icon: 'fas fa-times',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoIntestatarioDiverso,
        label: 'ANNULLATO PER INTESTATARIO DIVERSO',
        icon: 'fas fa-times',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.ChiamataBenvenutoNonRisponde,
        label: 'CHIAMATA DI BENVENUTO - NON RISPONDE',
        icon: 'fas fa-phone-square',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.PreVerificheBackoffice,
        label: 'PRE-VERIFICHE BACKOFFICE',
        icon: 'fas fa-check-double',
        color: Color.Gray,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.AnnullatoProvenienzaDefault,
        label: 'ANNULLATO PER PROVENIENZA DEFAULT/SALVAGUARDIA',
        icon: 'fas fa-times',
        color: Color.Red,
        icon2: null,
        color2: null
    },
    {
        phase: PhaseContract.DidettatoVolutaAttivazione,
        label: 'DISDETTATO PER VOLTURA CON ATTIVAZIONE',
        icon: 'fas fa-times',
        color: Color.Red,
        icon2: null,
        color2: null
    },
];



// WEBPACK FOOTER //
// ./src/app/helpers/phaseObjects.ts